import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";

import "./HotelInvoice.css";
import { bookingView } from "../../../../../Redux/slice/features/bookingSlice";
import { REACT_APP_API_URL } from "../../../../../env";
import PartialDayCancellationSummary from "./PartialDayCancellationSummary";

const cancellationPolicy = [
  {
    id: 1,
    window: "15 or more days",
    deduction: "20%",
    description: "20% deduction if cancelled 15 or more days before check-in date",
  },
  {
    id: 2,
    window: "7 to 14 days",
    deduction: "30%",
    description:
      "30% deduction if cancelled between 7 to 14 days before check-in date",
  },
  {
    id: 3,
    window: "2 to 6 days",
    deduction: "50%",
    description:
      "50% deduction if cancelled between 2 to 6 days before check-in date",
  },
  {
    id: 4,
    window: "Less than 2 days",
    deduction: "No cancellation allowed",
    description: "No cancellation allowed within 2 days of check-in date",
    isCritical: true,
  },
];

const BookingReceipt = () => {
  const { P_intBookingID } = useParams();

  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState([]);
  const [modificationLogs, setModificationLogs] = useState([]);
  const [modificationError, setModificationError] = useState("");

  const [totalAmount, setTotalAmount] = useState("0.00");
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/booking-view/${P_intBookingID}`
        );
        setSelectedBooking(response.data);
      } catch (error) {
        console.error(error.message, "error occurred");
      }
    };
    fetchReceipt();
  }, [P_intBookingID]);
  useEffect(() => {
    dispatch(bookingView(P_intBookingID));
  }, [dispatch, P_intBookingID]);

  useEffect(() => {
    const fetchModificationLogs = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/booking-modification-log/${P_intBookingID}`
        );
        if (response.data?.success) {
          setModificationLogs(response.data.data || []);
          setModificationError("");
        } else {
          setModificationLogs([]);
          setModificationError("No partial day cancellation data found.");
        }
      } catch (error) {
        console.error("Error fetching booking modification logs:", error);
        setModificationLogs([]);
        setModificationError("Failed to load partial day cancellation data.");
      }
    };

    if (P_intBookingID) {
      fetchModificationLogs();
    }
  }, [P_intBookingID]);

  useEffect(() => {
    if (selectedBooking?.data?.length > 0) {
      const amount = selectedBooking.data
        .reduce((acc, booking) => acc + (parseFloat(booking.Amount) || 0), 0)
        .toFixed(2);
      setTotalAmount(amount);

      const fetchBookingPayment = async () => {
        try {
          const response = await axios.get(
            `${REACT_APP_API_URL}api/dashboard/admin/booking-payment/${P_intBookingID}/${amount}`
          );
          
          setSelectedPayment(response.data.data);
        } catch (error) {
          console.error("Error fetching booking payment:", error);
        }
      };

      fetchBookingPayment();
    }
  }, [selectedBooking, P_intBookingID]);

  if (
    !selectedBooking ||
    !selectedBooking.data ||
    !Array.isArray(selectedBooking.data)
  ) {
    return <p>Loading receipt...</p>;
  }

  const rawBillDate = selectedBooking.data[0].BillDate || "";
  let formattedDate = "";
  let formattedTime = "";

  if (rawBillDate) {
    const [datePart, timePart] = rawBillDate.split(" ");
    formattedDate = datePart;
    formattedTime = timePart;
  }

  return (
    <div className="container mt-4 mb-4">
      <div className="border p-4 shadow-sm">
        {/* Header */}
        <div className="">
          <div className="row">
            <div className="col-sm-2 col-xs-3 sm3">
              <center className="image">
                <img src="/images/old-logo.png" alt="JTDC Logo" height="90" />
              </center>
            </div>
            <div className="col-sm-8 col-xs-6">
              <div className="maindiv print-center">
                <h3>
                  <strong>
                    Jharkhand Tourism Development Corporation Ltd.
                  </strong>
                </h3>
                <h6 style={{ textAlign: "center" }}>
                  A Govt. of Jharkhand Undertaking
                </h6>
                <p style={{ textAlign: "center" }}>
                  (6th Floor, Premium Suit Building, JUPMI Campus, Plant Plaza
                  Road, Dhurwa, Ranchi - 834004)
                </p>
                <p>
                  <p
                    id="lblServicetaxNo"
                    style={{ color: "Black", textAlign: "center" }}
                  >
                    GST Identification Number (GSTIN): 20AABCJ4014D6ZD
                  </p>
                </p>
              </div>
            </div>
            <div className="col-sm-2 col-xs-3 sm3 tourism-logo">
              <center>
                <img
                  src="/images/TourismLogo1.webp"
                  alt="Department of Tourism"
                />
              </center>
            </div>
          </div>
        </div>

        <div className="header-bottom">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="header-bottom_left">
                <p>
                  <b>Guest Name : </b>{" "}
                  {selectedBooking.data[0].CustomerName || ""}
                </p>
                <div className="shape"></div>
                <div className="shape"></div>
              </div>
            </div>
            <div className="col-auto">
              <div className="header-bottom_right">
                <div className="shape"></div>
                <div className="shape"></div>
                <p>
                  <b>Booking Ref: </b>{" "}
                  {selectedBooking.data[0].BookingRefNo || ""}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Booking Info */}
        <div className="row justify-content-between">
          <div className="col-auto">
            <div className="booking-info">
              <p>
                <b>Booking Date: </b> {formattedDate}
              </p>
              <p>
                <b>Booking Time: </b> {formattedTime}
              </p>
              <p>
                <b>Booking Type: </b> {selectedBooking.data[0].ChildAge1 || ""}
              </p>
            </div>
          </div>
          <div className="col-auto">
            <div className="booking-info">
              <p>
                <b>Booking Day(s): </b> {selectedBooking.data[0].NoOfDay || ""}
              </p>
              <p>
                <b>Check-In Date: </b>{" "}
                {selectedBooking.data[0].CheckinDate || ""}
              </p>
              <p>
                <b>Check-Out Date: </b>{" "}
                {selectedBooking.data[0].CheckOutDate || ""}
              </p>
            </div>
          </div>
          <div className="col-auto">
            <div className="booking-info">
              <p>
                <b>No of Room(s) Booked: </b>{" "}
                {selectedBooking.data.length || ""}
              </p>
              <p>
                <b>Payment Mode: </b> {selectedBooking.data[0].Age || ""}
              </p>
              <p>
                <b>Transaction No:</b>{" "}
                {selectedBooking.data[0].PaymentMode || ""}
              </p>
            </div>
          </div>
        </div>

        {/* Addresses */}
        <div className="row gx-0 flex-wrap print-row">
          <div className="col-md-6 col-12 mb-3 g-2">
            <div className="address-box address-left">
              <h6>Guest Information:</h6>
              <p>
                <b>Mobile No: </b>
                {selectedBooking.data[0].MobileNo || ""}
              </p>
              <p>
                <b>Email-Id: </b>
                {selectedBooking.data[0].EmailID || ""}
              </p>
              <p>
                <b>Address: </b>
                {selectedBooking.data[0].Address || ""}
              </p>
            </div>
          </div>
          <div className="col-md-6 col-12 mb-3 g-2">
            <div className="address-box address-right">
              <h6>Hotel Details:</h6>
              <p>
                <b>Unit Name: </b>
                {selectedBooking.data[0].PropertyName || "N/A"}
              </p>
              <p>
                <b>MR No: </b>
                {selectedBooking.data[0].vchMRNumber || "N/A"}
              </p>
              <p>
                <b>MR Date: </b>
                {selectedBooking.data[0].ChildAge2 || "N/A"}
              </p>
            </div>
          </div>
        </div>

        {/* Table */}
        <h5>Room Booking Summary</h5>
        <div className="table-responsive">
          <table
            className="table table-bordered table-hover shadow-sm rounded text-center align-middle"
            style={{ fontSize: "0.85rem" }}
          >
            <thead className="bg-light text-dark fw-semibold">
              <tr>
                <th>Sl#</th>
                <th>Room Type</th>
                <th>Adult</th>
                <th>Child</th>
                <th>Base Price (₹)</th>
                <th>Extra Person</th>
                <th>Extra Rate (₹)</th>
                <th>Subtotal (₹)</th>
                <th>Tax %</th>
                <th>Tax Amt (₹)</th>
                <th>Grand Total (₹)</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {selectedBooking?.data?.length > 0 ? (
                selectedBooking?.data?.map((booking, index) => (
                  <tr key={index}>
                    <td data-label="Sl#">{index + 1}</td>
                    <td data-label="Room Type">{booking.RoomTypeName}</td>
                    <td data-label="Adult">{booking.NoOfPerson}</td>
                    <td data-label="Child">{booking.NoOfChild}</td>
                    <td data-label="Base Price (₹)">{booking.PricePerDay}</td>
                    <td data-label="Extra Person">{booking.ExtraPerson}</td>
                    <td data-label="Extra Rate (₹)">
                      {booking.ExtraPersonRate}
                    </td>
                    <td data-label="Subtotal (₹)">{booking.Amount}</td>
                    <td data-label="Tax %">{booking.TaxType}</td>
                    <td data-label="Tax Amt (₹)">{booking.TotalAmount}</td>
                    <td data-label="Grand Total (₹)">
                      {booking.TaxPercentage}
                    </td>
                    <td data-label="Status">
                      <span
                        className={`badge`}
                        style={{
                          backgroundColor:
                            booking.Remarks === "Cancelled"
                              ? "#dc3545"
                              : "#0d6efd", 
                          color: "#fff",
                        }}
                      >
                        {booking.Remarks || ""}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" style={{ textAlign: "center" }}>
                    No Booking Details Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <PartialDayCancellationSummary
          modificationLogs={modificationLogs}
          modificationError={modificationError}
          roomBookings={selectedBooking?.data || []}
        />

        {/* Notes & Totals */}
        <div className="row justify-content-between mb-4">
          <div className="col-md-4">
            <h6>Tax Breakdown</h6>
            <table
              className="table table-bordered table-striped shadow-sm rounded text-center"
              style={{ fontSize: "0.75rem" }}
            >
              <thead>
                <tr>
                  <th>Tax Type</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedPayment?.map((payment, index) => (
                  <tr key={index}>
                    <td>{payment.TaxType || "N/A"}</td>
                    <td>
                      {payment.TaxAmount != null
                        ? parseFloat(payment.TaxAmount).toFixed(2)
                        : "0.00"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="col-md-8">
            <h6 id="Cancellation-table-heading">Cancellation Policy</h6>
            <table
              className="cancellation-table"
              style={{ fontSize: "0.9rem" }}
            >
              <thead>
                <tr>
                  <th>Sl#</th>
                  <th>Cancellation Window</th>
                  <th>Deduction</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {cancellationPolicy.map((policy) => (
                  <tr key={policy.id}>
                    <td data-label="Sl#">{policy.id}</td>
                    <td data-label="Window">{policy.window}</td>
                    <td
                      data-label="Deduction"
                      style={policy.isCritical ? { color: "red" } : {}}
                    >
                      {policy.deduction}
                    </td>
                    <td
                      data-label="Description"
                      style={policy.isCritical ? { color: "red" } : {}}
                    >
                      {policy.description}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="col-md-12 p-4 note-section">
          <h6>Please Note:</h6>
          <ul className="ul-with-bullets" style={{ fontSize: "0.9rem" }}>
            <li>
              This is an electronically generated receipt and is valid only when
              accompanied by an original government-issued photo ID such as
              Voter ID, Aadhaar, Passport, PAN Card, Driving License, or a
              Student ID issued by a recognized school or college.
            </li>
            <li>
              Please show this receipt along with your valid ID proof at the
              time of hotel booking or check-in. Without both, entry may be
              denied.
            </li>
            <li>
              The standard check-in time is <strong>12:00 PM</strong>, and
              check-out is at <strong>11:00 AM</strong>. Early check-in or late
              check-out may be subject to availability and additional charges.
            </li>
            <li>
              If your booking includes extra guests, please share their name,
              age, and relationship with you at the time of check-in with the
              hotel manager.
            </li>
            <li>
              Bookings made are non-transferable and cannot be shifted to
              another person.
            </li>
            <li>
              Cancellations are allowed according to the JTDC cancellation
              policy. Please check the policy details before making changes.
            </li>
            <li>
              Any refund, if applicable, will be credited back to the same
              account used during booking. Please ensure the account remains
              active. Room tariffs are subject to revision without prior notice.
            </li>
            <li>
              For any help or assistance, feel free to contact the Hotel Manager
              or the nearest Tourist Information Centre (TIC).
            </li>
          </ul>
        </div>

        {/* Footer Note */}
        <p
          className="invoice-note mt-3 text-center company-address"
          style={{ fontSize: "0.85rem" }}
        >
          <svg
            width="14"
            height="18"
            viewBox="0 0 14 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="" fill="#2D7CFE" />
          </svg>
          <b>NOTE: </b>This is computer generated receipt and does not require
          physical signature.
        </p>

        {/* Buttons */}
        <div className="d-flex gap-2 justify-content-end mt-4">
          <button
            className="btn btn-outline-success"
            onClick={() => setTimeout(() => window.print(), 300)}
            title="Print this invoice"
          >
            🖨️ Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingReceipt;
